module.exports = __webpack_public_path__ + "static/media/upload3d_full_active.36b4eae5.svg";